import React from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProvider } from 'formik'
import { Grid, Box, Button, Chip } from '@mui/material'
import { Delete } from '@mui/icons-material'

import useBalanceReportFilters from '@/views/balance-report/hooks/use-balance-report-filters.hooks'
import PlayerIdFilterType from './player-id.component'
import DateRangeFilterType from './date-range.component'

const BalanceReportFilters = () => {
  const { t } = useTranslation()

  const { formikBalanceReport, handleChangeSearch, handleBulkChangeSearch } =
    useBalanceReportFilters()

  const filtersValues = formikBalanceReport.values

  const activeChips: React.ReactNode[] = []

  const addChip = (key: string, label: string, displayValue: string) => {
    activeChips.push(
      <Chip
        key={key}
        label={`${label}: ${displayValue}`}
        onDelete={() => handleChangeSearch(key, '')}
        sx={{ margin: 0.5 }}
      />,
    )
  }

  if (filtersValues.playerId) {
    addChip('playerId', t('labels.playerId'), filtersValues.playerId)
  }

  const handleClearChips = () => {
    handleBulkChangeSearch({ playerId: '' })
  }

  return (
    <Box mb={3}>
      <FormikProvider value={formikBalanceReport}>
        <Box borderRadius={10} px={1.5} p={1}>
          <Box mb={2}>
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} md={3} lg={2}>
                <PlayerIdFilterType handleChangeSearch={handleChangeSearch} />
              </Grid>
              <DateRangeFilterType handleChangeSearch={handleChangeSearch} />
            </Grid>
          </Box>

          <Grid item xs={12}>
            <Box display="flex" flexWrap="wrap" mt={1}>
              {activeChips}
              {activeChips.length > 0 && (
                <Button
                  color="error"
                  onClick={handleClearChips}
                  sx={{
                    textTransform: 'none',
                    color: 'error.main',
                    '&:hover': {
                      backgroundColor: 'error.lighter',
                    },
                  }}
                  startIcon={<Delete />}
                >
                  {t('labels.clear')}
                </Button>
              )}
            </Box>
          </Grid>
        </Box>
      </FormikProvider>
    </Box>
  )
}

export default BalanceReportFilters
